import React, { useContext, memo } from "react";
import InfiniteScroll from "react-infinite-scroller";
import { MdOutlineSchool } from "react-icons/md";
import { Language } from "../../../App";
import CourseCard from "../cards/CourseCard";
import NewCourseCardShimmer from "../shimmers/NewCourseCardShimmer";
import "./SeeAllCourses.css";

function getGridColumnCount() {
  if (typeof window === "undefined") return 2;
  const width = window.innerWidth;
  if (width >= 2200) return 4;
  if (width > 1200) return 3;
  if (width > 768) return 2;
  return 1;
}

function useGridColumns() {
  const [columns, setColumns] = React.useState(getGridColumnCount);

  React.useEffect(() => {
    const handleResize = () => {
      setColumns(getGridColumnCount());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return columns;
}

const SeeAllCoursesCard = ({
  heading,
  cardData = [],
  checkMainPage,
  loading,
  loadMore,
  hasMore,
  cardsPerRow,
}) => {
  const { lang } = useContext(Language);
  const columns = useGridColumns();
  const effectiveCardsPerRow = cardsPerRow || (columns === 1 ? 2 : columns * 2);

  const ShimmerLoader = () => {
    return (
      <div className="cr-courses-grid mt-3">
        {Array.from({ length: effectiveCardsPerRow }, (_, index) => (
          <NewCourseCardShimmer width="100%" key={`shimmer-${index}`} />
        ))}
      </div>
    );
  };

  const renderCards = () => (
    <div className="cr-courses-grid mt-3">
      {cardData.map((course, index) => (
        <CourseCard
          key={course.id || index}
          course={course}
          width="100%"
        />
      ))}
    </div>
  );

  return (
    <>
      <div className="cr-see-all-section-header">
        <div className="cr-see-all-title-wrap">
          <h2 className="cr-see-all-section-title">{heading}</h2>
          <p className="cr-see-all-section-subtitle">
            {cardData?.length > 0
              ? `${cardData.length} ${cardData.length === 1 ? (lang?.course || "Course") : (lang?.courses || "Courses")}`
              : (lang?.explore_accredited_masterclasses || "Browse accredited medical masterclasses")}
          </p>
        </div>
        {cardData?.length > 0 && (
          <div className="cr-see-all-count-badge">
            <strong>{cardData.length}</strong> {cardData.length === 1 ? (lang?.course || "Course") : (lang?.courses || "Courses")}
          </div>
        )}
      </div>

      {loading ? (
        <ShimmerLoader />
      ) : cardData && cardData.length > 0 ? (
        <InfiniteScroll
          pageStart={0}
          loadMore={loadMore}
          hasMore={Boolean(hasMore)}
          useWindow={true}
          threshold={350}
          loader={<ShimmerLoader key="see-all-infinite-loader" />}
        >
          {renderCards()}
        </InfiniteScroll>
      ) : (
        <div className="cr-empty-state-card">
          <div className="cr-empty-icon-box">
            <MdOutlineSchool />
          </div>
          <h3 className="cr-empty-title">{lang?.no_courses_found || "No courses found"}</h3>
          <p className="cr-empty-desc">
            {lang?.no_courses_category_desc || "There are no courses currently available in this collection. Explore other categories or check back soon."}
          </p>
        </div>
      )}
    </>
  );
};

export default memo(SeeAllCoursesCard);